import { Component } from '@angular/core';
import { NotificationService } from '../services/notification.service';
import { BaseComponent } from '../../shared/base-components/base.component';
import { switchMap } from 'rxjs/operators';

@Component({
    selector: 'my-notifications',
    templateUrl: './my-notifications.html',
})
export class MyNotificationsComponent extends BaseComponent {
    public messages: any = new Array();
    public showDeleteAll = true;

    constructor(private notificationService: NotificationService) {
        super();
    }

    ngOnInit() {
        this.loadMessages();
    }

    loadMessages() {
        this.showDeleteAll = true;
        this.notificationService.getMessages().subscribe(result => {
            this.messages = result.result;
        });
    }

    deleteAll() {
        this.showDeleteAll = false;
        this.notificationService.deleteAllMessages().subscribe(result => {
            this.loadMessages();
        });
    }

    delete(notificationMessageDispositionId) {
        this.notificationService.markMessageRead(notificationMessageDispositionId)
            .pipe(switchMap(() => this.notificationService.deleteMessage(notificationMessageDispositionId)))
            .subscribe(() => this.loadMessages());
    }
}
